module.exports = __webpack_public_path__ + "img/kodawari_menu.4f9420df.png";